<!--供应商管理 供应商列表  供货能力-->
<template>
  <div>
    <el-row style="margin-bottom: -20px;">
      <h3>供应商名称：{{ this.supplierName }}</h3>
    </el-row>
    <el-row>
      <el-col>
        <el-form :inline="true" class="demo-form-inline" :model="searchForm" :ref="searchForm"
                 style="margin: 0">
          <el-form-item label="产品名称：">
            <el-input size="medium" placeholder="名称" minlength="10" maxlength="16" v-model="searchForm.NAME" clearable
                      @keyup.enter.native="filter()"></el-input>
          </el-form-item>
          <el-form-item label="产品编码：">
            <el-input size="medium" placeholder="编码" minlength="10" maxlength="16" v-model="searchForm.CODE" clearable
                      @keyup.enter.native="filter()"></el-input>
          </el-form-item>
          <el-form-item label="状态：">
            <label slot="label">状&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;态：</label>
            <el-select size="medium" filterable v-model="searchForm.STATUS" placeholder="请选择" >
              <el-option v-for="item in statusList" :key="item.status" :label="item.name" :value="item.status">
              </el-option>
            </el-select>
          </el-form-item>
          <el-button size="medium" type="primary" @click="filter" :loading="loadSearch">筛选</el-button>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <!--      <el-button size="medium" v-if="this.searchForm.STATUS == 0" @click="批量在售()">批量在售</el-button>-->
      <!--      <el-button size="medium" v-if="this.searchForm.STATUS == 1" @click="批量不在售()">批量不在售</el-button>-->
      <!--      <el-button size="medium" @click="importProductVisible = true">导入供货能力</el-button>-->
      <!--      <el-button size="medium" @click="addFormVisible = true">新增供应产品</el-button>-->
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe style="width: 100%;margin-top: 20px"
                  @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="39"></el-table-column>
          <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码" min-width="80"></el-table-column>
          <el-table-column prop="NAME" label="产品名称" min-width="200"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位" min-width="150"></el-table-column>
          <el-table-column label="状态" min-width="120" f>
            <template slot-scope="scope">
              <span :style="{ 'color': scope.row.ON_SALE ? '#67c23a' : '#f56c6c' }">
                {{ statusList[scope.row.ON_SALE].name }}
              </span>
            </template>
          </el-table-column>
          <!--          <el-table-column fixed="right" label="操作">-->
          <!--            <template slot-scope="scope">-->
          <!--              <el-button type="text" size="small" icon="el-icon-check" style="color: #67c23a"-->
          <!--                @click="listProduct(scope.row)" v-if="scope.row.STATUS == 0">上架</el-button>-->
          <!--              <el-button type="text" size="small" style="color: #f56c6c" icon="el-icon-close"-->
          <!--                @click="delistProduct(scope.row)" v-else>下架</el-button>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
        </el-table>
      </el-col>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
                       layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
    <!-- 导入供应能力 -->
    <el-dialog title="导入供应能力" center :visible.sync="importProductVisible" width="500px">
      <el-form ref="importForm" v-model="importForm" style="margin-left: 30px">
        <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-success="handleSuccess"
                   :on-remove="handleRemove" :name="this.importForm.file" multiple :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
        <p style="color: #409eff" @click="downloadTmp">点击下载导入模板</p>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importProductVisible = false">取 消</el-button>
        <el-button @click="importSupplyCapacity">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 批量上架 -->
    <el-dialog title="批量上架" center :visible.sync="batchListVisible" width="1300px">
      <el-table :data="batchListTable">
        <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
        <el-table-column prop="PRODUCT_CODE" label="产品编码" min-width="80"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="产品名称" min-width="200"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位" min-width="50"></el-table-column>
        <el-table-column label="当期价格" min-width="150" v-if="userPriceType == 1">
          <template slot-scope="scope">
            <el-input v-model="scope.row.CURRENT_PRICE" placeholder="请输入价格" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column label="下期价格" min-width="150" v-if="userPriceType == 1">
          <template slot-scope="scope">
            <el-input v-model="scope.row.NEXT_PRICE" placeholder="请输入价格" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column label="生效日期" min-width="150" v-if="userPriceType == 1">
          <template slot-scope="scope">
            <el-date-picker v-model="scope.row.NEXT_EFFECTIVE_DATE" placeholder="请选择生效日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column label="价格" min-width="150" v-if="userPriceType == 2">
          <template slot-scope="scope">
            <el-input v-model="scope.row.PRICE" placeholder="请输入价格" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column label="开始日期" min-width="150" v-if="userPriceType == 2">
          <template slot-scope="scope">
            <el-date-picker v-model="scope.row.START_DATE" placeholder="请选择日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column label="结束日期" min-width="150" v-if="userPriceType == 2">
          <template slot-scope="scope">
            <el-date-picker v-model="scope.row.END_DATE" placeholder="请选择日期" value-format="yyyy-MM-dd"></el-date-picker>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchListVisible = false">取 消</el-button>
        <el-button @click="submitBatchList" :disabled="submitBatchListDisabled">确认上架</el-button>
      </div>
    </el-dialog>
    <!-- 上架 -->
    <el-dialog :visible.sync="listProductVisible" title="上架商品" @close="listProductVisible = false" width="600px" center
               :inline="true" :close-on-click-modal="false">
      <el-form ref="listProductForm" v-model="listProductForm">
        <el-form-item label="产品代码：" prop="PRODUCT_CODE" :label-width="formLabelWidth">
          <el-input v-model="listProductForm.PRODUCT_CODE" disabled></el-input>
        </el-form-item>
        <el-form-item label="商品名称：" prop="PRODUCT_NAME" :label-width="formLabelWidth">
          <label slot="label">商品名称：</label>
          <el-input v-model="listProductForm.PRODUCT_NAME" disabled></el-input>
        </el-form-item>
        <el-form-item label="单位：" prop="TYPE_UNIT" :label-width="formLabelWidth">
          <label slot="label">单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位：</label>
          <el-input v-model="listProductForm.TYPE_UNIT" disabled></el-input>
        </el-form-item>
        <div v-if="userPriceType == 1">
          <el-form-item label="当期价格：" :label-width="formLabelWidth">
            <el-input v-model="listProductForm.CURRENT_PRICE"></el-input>
          </el-form-item>
          <!--  @input="getAddPriceWithoutTax" -->
          <!-- <el-form-item label="当期不含税价格：" :label-width="formLabelWidth">
            <el-input v-model="listProductForm.PRICE_WITHOUT_TAX" disabled></el-input>
          </el-form-item> -->
          <el-form-item label="下期价格：" :label-width="formLabelWidth">
            <el-input v-model="listProductForm.NEXT_PRICE"></el-input>
            <!--  @input="getAddNextPriceWithoutTax" -->
          </el-form-item>
          <!-- <el-form-item label="下期不含税价格：" :label-width="formLabelWidth">
            <el-input v-model="listProductForm.NEXT_PRICE_WITHOUT_TAX" disabled></el-input>
          </el-form-item> -->
          <el-form-item label="生效日期：" :label-width="formLabelWidth">
            <el-date-picker v-model="listProductForm.NEXT_EFFECTIVE_DATE" align="right" type="date" placeholder="选择日期"
                            value-format="yyyy-MM-dd" :picker-options="pickerOptions1" style="width:100%">
            </el-date-picker>
          </el-form-item>
        </div>
        <div v-else>
          <el-form-item label="单价：" :label-width="formLabelWidth">
            <el-input v-model="listProductForm.PRICE"></el-input>
            <!--  @input="getAddPriceWithoutTax" -->
          </el-form-item>
          <!-- <el-form-item label="不含税单价：" :label-width="formLabelWidth">
            <el-input v-model="listProductForm.PRICE_WITHOUT_TAX" disabled></el-input>
          </el-form-item> -->
          <el-form-item label="开始日期：" :label-width="formLabelWidth">
            <el-date-picker v-model="listProductForm.START_DATE" align="right" type="date" placeholder="选择日期"
                            value-format="yyyy-MM-dd" :picker-options="pickerOptions2" style="width:100%">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束日期：" :label-width="formLabelWidth">
            <el-date-picker v-model="listProductForm.END_DATE" align="right" type="date" placeholder="选择日期"
                            value-format="yyyy-MM-dd" :picker-options="pickerOptions2" style="width:100%">
            </el-date-picker>
          </el-form-item>
        </div>
        <el-form-item label="是否为缺省：" prop="BE_DEFAULT" :label-width="formLabelWidth">
          <el-radio v-model="listProductForm.BE_DEFAULT" label="0">否</el-radio>
          <el-radio v-model="listProductForm.BE_DEFAULT" label="1">是</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="listProductVisible = false">取 消</el-button>
        <el-button @click="submitListProduct">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 新增供应产品 -->
    <el-dialog :visible.sync="addFormVisible" title="新增供应产品" @close="closeAddForm" width="400px" center
               :inline="true" :close-on-click-modal="false">
      <el-form ref="addForm" v-model="addForm">
        <el-form-item label="产品名称：">
          <el-autocomplete class="inline-input" v-model="addForm.PRODUCT_NAME" :fetch-suggestions="querySearchadd"
                           placeholder="输入产品名称添加" :trigger-on-focus="false" @select="handleSelect" clearable></el-autocomplete>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeAddForm">取 消</el-button>
        <el-button @click="submitAdd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { putAway } from 'api/systemSetting';
// import { getActionFun } from 'api/login';
import http from '@/assets/common/http';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      statusList: [{ status: '0', name: '不在售' }, { status: '1', name: '在售' }],
      userPriceType: sessionStorage.getItem('PRICE_MODE'),
      tableData: [],
      supplierName: sessionStorage.getItem('supplierNameAboutCapacity') || '',
      checkedArray: [],
      batchListTable: [],
      batchDelistTable: [],
      reg: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/,
      formLabelWidth: '140px',
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now();// 如果没有后面的-8.64e7就是不可以选择今天的
        },
      },
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;// 如果没有后面的-8.64e7就是不可以选择今天的
        },
      },
      loadSearch: false,
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      searchForm: {
      },
      listProductVisible: false,
      listProductForm: {},
      fileList: [],
      importProductVisible: false,
      importForm: {
        file: 'tmp',
      },
      batchListVisible: false,
      addForm: {},
      addFormVisible: false,
      // PAGE_ID: '1080001', // 页面ID 一旦规定不要轻易改动
      // fun_dic: { 108000101: 0 },
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    // if (this.SAVE_DSORDER_LIST) {
    //   this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
    //   this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    // } else {
    //   this.currentPage = 1;
    // }
    // if (JSON.stringify(this.SAVE_SUPPLIER_LIST) != '{}' && this.SAVE_SUPPLIER_LIST != 'undefined') {
    //   this.searchForm = this.SAVE_SUPPLIER_LIST.CONDITION;
    //   this.currentPage = this.SAVE_SUPPLIER_LIST.CURRENT_PAGE;
    // }
    this.queryProduct();
    // this.queryBeforeFun();
  },
  computed: {
    // SAVE_SUPPLIER_LIST() {
    //   return this.$store.state.SUPPLIER_LIST;
    // },
    submitBatchListDisabled() {
      if (this.userPriceType == 1) {
        if (this.batchListTable.find((item) => !this.reg.test(item.CURRENT_PRICE) || !this.reg.test(item.CURRENT_PRICE) || !item.NEXT_EFFECTIVE_DATE)) {
          return true;
        }
      } else {
        if (this.batchListTable.find((item) => !this.reg.test(item.PRICE) || !item.START_DATE || !item.END_DATE)) {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    // 控制功能按钮
    // queryBeforeFun() {
    //   const params = {
    //     PAGE_ID: this.PAGE_ID,
    //   };
    //   getActionFun(params)
    //     .then((result) => {
    //       if (result.length !== 0) {
    //         this.forMenu(result, this.fun_dic);
    //       }
    //     }).catch((error) => {
    //       this.$message.show({ text: error, type: 'error' });
    //     });
    // },
    // forMenu(e) {
    //   const tmp_fun_list = e;
    //   for (let i = 0; i < tmp_fun_list.length; i++) {
    //     for (const key in this.fun_dic) {
    //       if (tmp_fun_list[i].FUNCTION_NUM == key) {
    //         this.fun_dic[key] = 1;
    //       }
    //     }
    //   }
    // },
    // 分页
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryProduct();
    },
    // 筛选
    filter() {
      this.currentPage = 1;
      this.queryProduct();
    },
    // 拉取数据
    queryProduct() {
      if (!validation.产品编码验证(this.searchForm.CODE)) {
        this.$message.show({ text: '产品编码只能输入数字', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10008',
        OTYPE: 20,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        SUPPLIER_ID: this.$route.params.sid,
        PAGE_INDEX: this.currentPage - 1,
        PAGE_SIZE: this.pageSize,
        PRICE_MODE: this.userPriceType,
      };
      if (this.searchForm.CODE) {
        params.PRODUCT_CODE = this.searchForm.CODE;
      }
      if (this.searchForm.NAME) {
        params.PRODUCT_NAME = this.searchForm.NAME;
      }
      if (this.searchForm.STATUS) {
        params.ON_SALE = Number(this.searchForm.STATUS);
      }
      this.loadSearch = true;
      http.post(params).then((res) => {
        if (res.length > 0) {
          this.tableData = res[0].list;
          this.totalCount = res[0].TOTAL_COUNT;
          this.loadSearch = false;
        } else {
          this.tableData = [];
          this.totalCount = 0;
        }
        this.loadSearch = false;
      }).catch((err) => {
        this.loadSearch = false;
        this.$message.show({ text: err, type: 'error' });
      });
    },
    批量在售() {
      if (this.searchForm.STATUS != 0) {
        this.$message.show({ text: '请先筛选不在架产品', type: 'warning' });
        return false;
      }
      if (this.checkedArray == '') {
        this.$message.show({ text: '请先选择要上架的产品', type: 'warning' });
        return false;
      }
      this.batchListTable = [...this.checkedArray];
      this.batchListVisible = true;
    },
    async submitBatchList() {
      const paramsList = this.userPriceType == 1
        ? this.checkedArray.map((item) => ({
          PRODUCT_CODE: item.PRODUCT_CODE,
          PRICE_MODE: 1,
          CURRENT_PRICE: item.CURRENT_PRICE,
          NEXT_PRICE: item.NEXT_PRICE,
          NEXT_EFFECTIVE_DATE: item.NEXT_EFFECTIVE_DATE,
          SUPPLIER_ID: Number(this.$route.params.sid),
        }))
        : this.checkedArray.map((item) => ({
          PRODUCT_CODE: item.PRODUCT_CODE,
          PRICE_MODE: 2,
          PRICE: item.PRICE,
          START_DAY: item.START_DATE,
          END_DAY: item.END_DATE,
          SUPPLIER_ID: Number(this.$route.params.sid),
        }));
      const resList = [];
      const erroeList = [];
      let index = 0;
      for (const item of paramsList) {
        try {
          // eslint-disable-next-line no-await-in-loop
          const res = await putAway(item);
          resList.push(res);
        } catch (e) {
          erroeList.push(index);
        } finally {
          index++;
        }
      }
      if (erroeList.length) {
        this.$message.show({ text: '部分商品上架失败', type: 'warning' });
      } else {
        this.$message.show({ text: '批量上架成功', type: 'success' });
        this.batchListVisible = false;
        this.queryProduct();
      }
    },
    listProduct(row) {
      this.listProductForm = { ...row };
      this.listProductVisible = true;
    },
    submitListProduct() {
      const params = this.userPriceType == 1
        ? {
          PRODUCT_CODE: this.listProductForm.PRODUCT_CODE,
          PRICE_MODE: 1,
          BE_DEFAULT: this.listProductForm.BE_DEFAULT,
          CURRENT_PRICE: this.listProductForm.CURRENT_PRICE,
          NEXT_PRICE: this.listProductForm.NEXT_PRICE,
          NEXT_EFFECTIVE_DATE: this.listProductForm.NEXT_EFFECTIVE_DATE,
          SUPPLIER_ID: Number(this.$route.params.sid),
        }
        : {
          PRODUCT_CODE: this.listProductForm.PRODUCT_CODE,
          PRICE_MODE: 2,
          BE_DEFAULT: this.listProductForm.BE_DEFAULT,
          PRICE: this.listProductForm.PRICE,
          START_DAY: this.listProductForm.START_DATE,
          END_DAY: this.listProductForm.END_DATE,
          SUPPLIER_ID: Number(this.$route.params.sid),
        };
      putAway(params).then((result) => {
        this.$message.show({ text: '上架成功', type: 'success' });
        this.listProductVisible = false;
        this.queryProduct();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    async 批量不在售() {
      // if (this.searchForm.STATUS != 1) {
      //   this.$message.show({ text: '请先筛选在架产品', type: 'warning' });
      //   return false;
      // }
      if (this.checkedArray == '') {
        this.$message.show({ text: '请先选择要下架的产品', type: 'warning' });
        return false;
      }
      this.$confirm('您确定下架选中的产品吗?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(async () => {
        const paramsList = this.checkedArray.map((item) => ({
          SERVICE_ID: '10008',
          OTYPE: 21,
          PRODUCT_CODE: item.PRODUCT_CODE,
          PRICE_MODE: this.userPriceType,
          SUPPLIER_ID: this.$route.params.sid,
          GYS_ID: Number(sessionStorage.getItem('tcId')),
          DETAIL_ID: item.DETAIL_ID,
        }));
        const resList = [];
        const erroeList = [];
        let index = 0;
        for (const item of paramsList) {
          try {
            // eslint-disable-next-line no-await-in-loop
            const res = await http.post(item);
            resList.push(res);
          } catch (e) {
            erroeList.push(index);
          } finally {
            index++;
          }
        }
        if (erroeList.length) {
          this.$message.show({ text: '部分商品下架失败', type: 'warning' });
        } else {
          this.$message.show({ text: '批量下架成功', type: 'success' });
          this.batchListVisible = false;
          this.queryProduct();
        }
      }).catch(() => {
        this.$message.show({ type: 'info', text: '取消操作' });
      });
    },
    delistProduct(row) {
      this.$confirm('您确定下架该产品吗?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(async () => {
        const params = {
          SERVICE_ID: '10008',
          OTYPE: 21,
          PRODUCT_CODE: row.PRODUCT_CODE,
          PRICE_MODE: this.userPriceType,
          SUPPLIER_ID: this.$route.params.sid,
          GYS_ID: Number(sessionStorage.getItem('tcId')),
          DETAIL_ID: row.DETAIL_ID,
        };
        http.post(params).then((res) => {
          this.$message.show({ text: '下架成功', type: 'success' });
          this.queryProduct();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }).catch(() => {
        this.$message.show({ type: 'info', text: '取消操作' });
      });
    },
    // 导入供应能力
    handleSuccess(response, file, fileList) {
      this.url = response.file_name;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      this.url = '';
    },
    downloadTmp() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/importSupplyCapacityTemp.xls';
    },
    // 导入模态框的提交
    importSupplyCapacity() {
      if (!this.url) {
        this.$message.show({ text: '请上传文件', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10072',
        OTYPE: 25,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        SUPPLIER_ID: Number(this.$route.params.sid),
        FILE_NAME: this.url,
      };
      http.post(params)
        .then((result) => {
          if (result[0].FILE_PATH == '') {
            this.$message.show({ text: '导入成功', type: 'success' });
            this.url = '';
            this.$refs.upload.clearFiles();
            this.importProductVisible = false;
            this.fileList = [];
            this.queryProduct();
            document.body.style.cursor = 'default';
          } else {
            this.$message.show({ text: '部分产品导入异常，详情查看下载文件', type: 'error' });
            this.url = '';
            this.$refs.upload.clearFiles();
            this.importProductVisible = false;
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            this.fileList = [];
            document.body.style.cursor = 'default';
            this.queryProduct();
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          this.url = '';
          this.$refs.upload.clearFiles();
          document.body.style.cursor = 'default';
        });
    },
    handleSelectionChange(val) {
      this.checkedArray = val;
    },
    querySearchadd(queryString, callback) {
      const params = {
        SERVICE_ID: '10008',
        OTYPE: 50,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        SUPPLIER_ID: this.$route.params.sid,
        PRICE_MODE: this.userPriceType,
        PRODUCT_NAME: this.addForm.PRODUCT_NAME,
      };
      http.post(params).then((res) => {
        const tmpArr = res[0].list.map((item) => ({
          PRODUCT_NAME: item.NAME,
          PRODUCT_CODE: item.INNER_CODE,
          TYPE_UNIT: item.TYPE_UNIT,
        }));
        const results = tmpArr.map((item) => {
          item.value = `${item.PRODUCT_NAME}(${item.TYPE_UNIT})`;
          return item;
        });
        callback(results);
      }).catch((err) => {
        callback([]);
      });
    },
    // 挑选
    handleSelect(item) {
      this.addForm = item;
    },
    submitAdd() {
      const params = {
        SERVICE_ID: '10008',
        OTYPE: 51,
        SUPPLIER_ID: this.$route.params.sid,
        PRODUCT_CODE: this.addForm.PRODUCT_CODE,
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '添加成功', type: 'success' });
        this.queryProduct();
        this.closeAddForm();
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    closeAddForm() {
      this.addFormVisible = false;
      this.addForm = {};
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/supplierManage/supplyCapacity.vue